import { Injectable } from "@angular/core";
import mixpanel from "mixpanel-browser";

const MIXPANEL_TOKEN = "1047d508d8385bcef61e50946433713d";

@Injectable({
  providedIn: "root",
})
export class MixpanelService {
  constructor() {
    mixpanel.init(MIXPANEL_TOKEN, {
      debug: true,
      track_pageview: true,
      persistence: "localStorage",
      record_sessions_percent: 100,
      record_heatmap_data: true,
    });
  }

  identify(userId: string) {
    mixpanel.identify(userId);
  }

  track(eventName: string, properties?: any) {
    mixpanel.track(eventName, properties);
  }

  setUserProperties(properties: any) {
    mixpanel.people.set(properties);
  }
}
